import React from "react";
import { useProductSelector } from "../../stores/product/product.store";
import { ProductState } from "../../stores/product/product-state.interface";
import { ProductInterface } from "../../interfaces/product/product.interface";
import { Notification } from "./buttons/Notification";
interface NotInStockButtons {
    onClickNotification: () => void;
    similareLink: string
}

export const NotInStockButtons: React.FC<NotInStockButtons> = ({ onClickNotification, similareLink }) => {
    const translate = useProductSelector((state: ProductState) => state.translate);
    return (
        <>
            <Notification onClick={ onClickNotification } />
            <a href={ similareLink } className="rounded-2xl p-4 w-full bg-[#f78122] font-bold text-[16px] inline-block text-center">
                {translate.similare}
            </a>
        </>
    )
}